/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Modal, notification, Row, Select, Typography } from 'antd';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  addAdminMaintenanceTypes,
  deleteAdminMaintenanceTypes,
  updateAdminMaintenanceTypes,
} from '../../redux/admin/maintenance/action';
import ModalCustomSelect from '../common/ModalCustomSelect';

const { Option } = Select;
const { Text } = Typography;

const MODAL_CUSTOM_SELECT_Z = 5000200;

const AddNewMaintenanceType = (props) => {
  const {
    setModalOpen,
    modalOpen,
    modalText,
    update,
    maintenanceTypesList,
    isDelete,
    isModernPage = false,
  } = props;
  const {
    onAddMaintenanceTypes,
    isAddAdminMaintenanceTypesLoading,
    isMaintenanceTypeUpdateLoading,
    onUpdateMaintenanceTypes,
    onDeleteMaintenanceTypes,
    isMaintenanceTypeDeleteLoading,
  } = props;

  const [maintenanceTypeForm] = Form.useForm();
  const [maintenanceText, setMaintenanceText] = useState('');
  const [maintenanceType, setMaintenanceType] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);

  /** Waiting to Add equipment type and close Modal */
  useEffect(() => {
    if (!isAddAdminMaintenanceTypesLoading) {
      setModalOpen(false);
      maintenanceTypeForm.resetFields();
      setMaintenanceText('');
      setMaintenanceType('');
      setConfirmDelete(false);
    }
  }, [isAddAdminMaintenanceTypesLoading]);

  /** Waiting to Update equipment type and close Modal */
  useEffect(() => {
    if (!isMaintenanceTypeUpdateLoading) {
      setModalOpen(false);
      maintenanceTypeForm.resetFields();
      setMaintenanceText('');
      setMaintenanceType('');
      setConfirmDelete(false);
    }
  }, [isMaintenanceTypeUpdateLoading]);

  /** Waiting to Delete equipment type and close Modal */
  useEffect(() => {
    if (!isMaintenanceTypeDeleteLoading) {
      setModalOpen(false);
      maintenanceTypeForm.resetFields();
      setMaintenanceText('');
      setMaintenanceType('');
      setConfirmDelete(false);
    }
  }, [isMaintenanceTypeDeleteLoading]);

  /** Adding or Updating Equipment types */
  const handleOk = () => {
    maintenanceTypeForm.validateFields().then(async (data) => {
      if (update) {
        if (data.maintenanceText && data.maintenanceType) {
          const typeId = maintenanceTypesList.find((u) => u.name === data.maintenanceType);
          var obj = {
            typeOfMaintenance: {
              name: data.maintenanceText,
            },
          };
          await onUpdateMaintenanceTypes({ data: obj, id: typeId.id });
        } else {
          notification.warning({
            message: 'Please Fill all the required Fields!',
          });
        }
      } else if (isDelete) {
        if (data.maintenanceType) {
          const typeId = maintenanceTypesList.find((u) => u.name === data.maintenanceType);

          await onDeleteMaintenanceTypes({ id: typeId.id });
        } else {
          notification.warning({
            message: 'Please Select Maintenance Type to Delete!',
          });
        }
      } else {
        if (data.maintenanceText) {
          var obj = {
            typeOfMaintenance: {
              name: data.maintenanceText,
            },
          };

          await onAddMaintenanceTypes(obj);
        } else {
          notification.warning({
            message: 'Please enter the Maintenance Type to proceed!',
          });
        }
      }
    });
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setModalOpen(false);
    maintenanceTypeForm.resetFields();
    setMaintenanceText('');
    setMaintenanceType('');
    setConfirmDelete(false);
  };

  /** Setting the value on selecting Maintenance type */
  const onChangeMaintenance = (value) => {
    setMaintenanceType(value);
    setMaintenanceText(value);
    maintenanceTypeForm.setFieldsValue({ maintenanceText: value });
    setConfirmDelete(true);
  };

  return (
    <div>
      <Modal
        width={isModernPage ? 520 : '45vw'}
        className={
          isModernPage
            ? 'heatprofile-modal pipeline-modal maintenance-type-modal'
            : 'pipeline-modal'
        }
        title={modalText}
        centered
        visible={modalOpen}
        zIndex={isModernPage ? 5000000 : undefined}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleOk}
            loading={
              isAddAdminMaintenanceTypesLoading ||
              isMaintenanceTypeUpdateLoading ||
              isMaintenanceTypeDeleteLoading
            }
          >
            {update
              ? isMaintenanceTypeUpdateLoading
                ? 'Updating'
                : 'Update'
              : isDelete
              ? isMaintenanceTypeDeleteLoading
                ? 'Deleting'
                : 'Confirm'
              : isAddAdminMaintenanceTypesLoading
              ? 'Adding'
              : 'Add'}
          </Button>,
        ]}
      >
        <Form
          form={maintenanceTypeForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
          getContainer={false}
        >
          <Row gutter={isModernPage ? [16, 16] : 24}>
            {(update || isDelete) && (
              <Col xs={24} lg={isModernPage ? 24 : isDelete ? 16 : 18}>
                <Form.Item
                  label={isDelete && 'Select Maintenance Type'}
                  name="maintenanceType"
                  required
                >
                  {isModernPage ? (
                    <ModalCustomSelect
                      className="heatprofile-maintenance-type-modal-select"
                      placeholder="Select Maintenance Type"
                      showSearch
                      parentOpen={modalOpen}
                      dropdownZIndex={MODAL_CUSTOM_SELECT_Z}
                      options={(maintenanceTypesList || [])
                        .filter((item) => item && item.name)
                        .map((item, idx) => ({
                          key: item.id != null ? item.id : `mt-${item.name}-${idx}`,
                          value: item.name,
                          label: item.name,
                        }))}
                      onSelect={onChangeMaintenance}
                    />
                  ) : (
                    <Select
                      className="client-select"
                      placeholder="Select Maintenance Type"
                      showSearch
                      optionFilterProp="children"
                      onChange={onChangeMaintenance}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    >
                      {maintenanceTypesList &&
                        maintenanceTypesList.map((item, i) => (
                          <Option key={i} value={item && item.name}>
                            {item && item.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            )}
            {!isDelete ? (
              <Col xs={24} lg={isModernPage ? 24 : 18}>
                <Form.Item label="Maintenance Type" name="maintenanceText" required>
                  <Input
                    placeholder={
                      update ? 'Edit selected Maintenance Type ' : 'Enter New Maintenance Type'
                    }
                    value={maintenanceText}
                    onChange={(e) => setMaintenanceText(e.target.value)}
                    size={isModernPage ? 'middle' : 'large'}
                    disabled={update && !maintenanceType}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col xs={24}>
                <div
                  className={isModernPage ? 'equip-check-delete-body' : undefined}
                  style={isModernPage ? undefined : { padding: '0 16px' }}
                >
                  {confirmDelete && (
                    <Text
                      style={{
                        fontSize: isModernPage ? 15 : 16,
                        color: isModernPage ? '#374151' : undefined,
                      }}
                    >
                      <p style={isModernPage ? { marginBottom: 12 } : undefined}>
                        Deleting Maintenance Type will delete all the corresponding checks
                        information.
                      </p>
                      Are you sure you want to delete{' '}
                      <b style={{ color: isModernPage ? '#00C9A7' : '#EF314C' }}>
                        {maintenanceType}
                      </b>{' '}
                      Maintenance Type?
                    </Text>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ maintenanceAdminReducer }) => {
  const isAddAdminMaintenanceTypesLoading = get(
    maintenanceAdminReducer,
    'isAddAdminMaintenanceTypesLoading',
    false
  );
  const isMaintenanceTypeUpdateLoading = get(
    maintenanceAdminReducer,
    'isMaintenanceTypeUpdateLoading',
    false
  );
  const isMaintenanceTypeDeleteLoading = get(
    maintenanceAdminReducer,
    'isMaintenanceTypeDeleteLoading',
    false
  );
  return {
    isAddAdminMaintenanceTypesLoading,
    isMaintenanceTypeUpdateLoading,
    isMaintenanceTypeDeleteLoading,
  };
};

const mapDispatchToProps = {
  onAddMaintenanceTypes: addAdminMaintenanceTypes,
  onUpdateMaintenanceTypes: updateAdminMaintenanceTypes,
  onDeleteMaintenanceTypes: deleteAdminMaintenanceTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewMaintenanceType);
